import { request } from '@remote/api/request'
import { guid } from '@remote/utils'
import WebsocketClient from './ws'

interface IGetWSAddressReponse {
  /** ws地址域名（不携带协议） */
  addr: string
}

async function getDynamicWSAddress () {
  const url = '/api/v1/ws/get_ws_addr'
  return request(url).then(response => {
    console.log('[get_ws_addr]response:', response)
    const [, { code, msg, data }]: [null, {code: number; msg:string; data:IGetWSAddressReponse}] = response
    if (code !== 200 || !data) {
      throw new Error(msg)
    }
    console.log('获取到ws动态地址:', data.addr)
    return data.addr
  })
}

export async function createWSConf (deviceId: string): Promise<{ url: string; wsWebQuery: string; wsServerQuery: string }> {
  let host = ''
  try {
    host = await getDynamicWSAddress()
    if (!host) host = 'ws016447-nas.n0808.com'
  } catch {
    host = 'ws016447-nas.n0808.com'
  }

  const protocol = 'wss://'
  // const url = 'wss://ws016447-nas.n0808.com'
  const url = protocol + host
  const clientId = guid()
  const webClientId = `${clientId}_web`
  const serverClientId = `${clientId}_server`
  const platform = 'RN'
  // const deviceId = global.deviceId

  return {
    url,
    wsWebQuery: `?userId=${webClientId}&toUserId=${serverClientId}&deviceID=${deviceId}&platForm=${platform}`,
    wsServerQuery: `?userId=${serverClientId}&toUserId=${webClientId}&deviceID=${deviceId}&platForm=${platform}`,
  }
}

export default WebsocketClient
